import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { ReactNode } from 'react'
import LoadingSpinner from './LoadingSpinner'
import { hasAnyRole } from '../utils/roles'

interface ProtectedRouteProps {
  children: ReactNode
  /** When set, the user must hold at least one of these roles (admin passes unless `adminBypass` is false). */
  requiredRoles?: string[]
  /** false = admin must hold the role too (Bruktbil, #673). Defaults to true. */
  adminBypass?: boolean
}

export default function ProtectedRoute({ children, requiredRoles, adminBypass = true }: ProtectedRouteProps) {
  const { user, loading } = useAuth()
  const location = useLocation()

  // Wait for auth check to complete before redirecting
  if (loading) {
    return <LoadingSpinner />
  }

  if (!user) {
    // Redirect to login, but save the location they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (requiredRoles && requiredRoles.length > 0 && !hasAnyRole(user, requiredRoles, adminBypass)) {
    // Authenticated but lacks the role — send them somewhere they can see
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
